(function () {
    'use strict';

    angular.module("imApp").factory("acReportLayoutService", ['$ihttp', function ($ihttp) {
        let service = {
            getAcReportLayout: function (parms) {
                return $ihttp.post({
                    method: 2803,
                    parameters: parms || {}
                });
            },
            listAcReportLayouts: function (parms) {
                return $ihttp.post({
                    method: 2812,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2804,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
